var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97468 0C10.9091 0 13.3593 2.23757 13.625 5.15991L14.0318 9.63575C14.0676 10.0287 14.304 10.3751 14.6569 10.5516L14.6601 10.5532C15.4503 10.9482 15.9494 11.7558 15.9494 12.6392V12.9873C15.9494 14.1199 15.0313 15.038 13.8987 15.038H10.481V15.4937C10.481 16.8779 9.35889 18 7.97468 18C6.59048 18 5.46835 16.8779 5.46835 15.4937V15.038H2.05063C0.9181 15.038 0 14.1199 0 12.9873V12.6392C0 11.7558 0.499111 10.9482 1.28925 10.5532L1.29244 10.5516C1.64533 10.3751 1.8818 10.0287 1.91752 9.63575L2.32442 5.15991C2.59008 2.23757 5.0403 0 7.97468 0ZM6.83544 15.038V15.4937C6.83544 16.1229 7.3455 16.6329 7.97468 16.6329C8.60387 16.6329 9.11392 16.1229 9.11392 15.4937V15.038H6.83544ZM7.97468 1.36709C5.74736 1.36709 3.88754 3.0655 3.68589 5.28368L3.279 9.75952C3.20041 10.6239 2.68017 11.3862 1.90382 11.7743C1.57364 11.9394 1.36709 12.2736 1.36709 12.6392V12.9873C1.36709 13.3649 1.67312 13.6709 2.05063 13.6709H13.8987C14.2762 13.6709 14.5823 13.3649 14.5823 12.9873V12.6392C14.5823 12.2736 14.3757 11.9394 14.0487 11.7759C13.2692 11.3862 12.749 10.6239 12.6704 9.75952L12.2635 5.28368C12.0618 3.0655 10.202 1.36709 7.97468 1.36709Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.d41150568d0cf71d901280a383bccd4a.svg";
export { ForwardRef as ReactComponent };